module.exports = __webpack_public_path__ + "img/safari-pinned-tab.cba90668.svg";